var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "6px",
    viewBox: "0 0 21 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Eyes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-25",
    transform: "translate(-205.000000, -58.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.425902,15.3181483 C36.9111833,15.3181483 38.925902,16.661294 38.925902,18.3181483 C38.925902,19.9750025 36.9111833,21.3181483 34.425902,21.3181483 C31.9406206,21.3181483 29.925902,19.9750025 29.925902,18.3181483 C29.925902,16.661294 31.9406206,15.3181483 34.425902,15.3181483 Z M46.425902,15.3181483 C48.9111833,15.3181483 50.925902,16.661294 50.925902,18.3181483 C50.925902,19.9750025 48.9111833,21.3181483 46.425902,21.3181483 C43.9406206,21.3181483 41.925902,19.9750025 41.925902,18.3181483 C41.925902,16.661294 43.9406206,15.3181483 46.425902,15.3181483 Z",
    id: "Eyes---round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/Eyes.77d809b31b6fd1bfaaddf4645eda7741.svg";
export { ForwardRef as ReactComponent };